<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g stroke="currentColor" style="fill:none"><circle cx="8" cy="8" r="8" stroke="none" style="stroke:none"/><circle cx="8" cy="8" r="7.5" style="fill:none"/></g><path d="M8.847 4.424a.924.924 0 1 1-.924-.924.924.924 0 0 1 .924.924" fill="currentColor"/><path d="M9.275 11.089h-.644V6.76a.611.611 0 0 0-.61-.611H6.758a.611.611 0 0 0 0 1.222h.652v3.718h-.644a.611.611 0 0 0 0 1.221h2.509a.611.611 0 1 0 0-1.221" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-info',
});
</script>
